import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-gray dark:prose-invert max-w-none leading-relaxed">
          <h2>Privacy Policy for Madura Mercerisers India Private Limited</h2>

          <p>
            This Privacy Policy describes our policies and procedures on the
            collection, use and disclosure of your information when you use our
            Service and explains your privacy rights and how the law protects
            you. By using the Service, you agree to the collection and use of
            information in accordance with this Privacy Policy.
          </p>

          <h2>Interpretation and Definitions</h2>
          <h3>Interpretation</h3>
          <p>
            The words whose initial letters are capitalized have meanings
            defined under the following conditions. These definitions shall have
            the same meaning whether they appear in singular or plural.
          </p>

          <h3>Definitions</h3>
          <ul>
            <li>
              <strong>Account</strong> means a unique account created for you to
              access our Service.
            </li>
            <li>
              <strong>Affiliate</strong> means an entity that controls, is
              controlled by, or is under common control with a party, where
              "control" means ownership of 50% or more of the voting securities.
            </li>
            <li>
              <strong>Company</strong> (referred to as “the Company”, “We”, “Us”
              or “Our”) refers to{" "}
              <em>Madura Mercerisers India Private Limited</em>, No: 5/487 D,
              Angeripalayam Main Road, Vengamedu, Tirupur – 641 603.
            </li>
            <li>
              <strong>Cookies</strong> are small files placed on your device to
              store browsing information.
            </li>
            <li>
              <strong>Country</strong> refers to: Tamil Nadu, India.
            </li>
            <li>
              <strong>Device</strong> means any device that can access the
              Service such as a computer, cellphone or digital tablet.
            </li>
            <li>
              <strong>Personal Data</strong> means any information relating to
              an identified or identifiable individual.
            </li>
            <li>
              <strong>Service</strong> refers to the website
              <a
                href="https://www.maduramercerisers.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 underline ml-1"
              >
                www.maduramercerisers.com
              </a>
              .
            </li>
            <li>
              <strong>You</strong> means the individual accessing or using the
              Service, or the company or other legal entity on whose behalf the
              Service is used.
            </li>
          </ul>

          <h2>Collecting and Using Your Personal Data</h2>
          <p>
            We may collect personally identifiable information such as name,
            email, phone number, address, and usage data. Usage data is
            collected automatically and may include IP address, browser type,
            and pages visited.
          </p>

          <h3>Tracking Technologies and Cookies</h3>
          <p>
            We use cookies and similar tracking technologies (beacons, tags,
            scripts) to monitor activity and improve our Service. You can choose
            to disable cookies in your browser, but some features may not
            function properly.
          </p>

          <h2>Use of Your Personal Data</h2>
          <ul className="list-disc pl-6">
            <li>To provide and maintain our Service.</li>
            <li>To manage your account and registration.</li>
            <li>
              To perform contracts or respond to your requests and inquiries.
            </li>
            <li>
              To contact you by email, phone, SMS, or other electronic means.
            </li>
            <li>
              To provide you with news, special offers, and relevant information
              unless you opt out.
            </li>
            <li>
              For business transfers, analytics, and improving our Service.
            </li>
          </ul>

          <h2>Retention and Transfer of Data</h2>
          <p>
            We retain Personal Data only as long as necessary to fulfill the
            purposes outlined in this policy and to comply with legal
            obligations. Your information may be transferred to and maintained
            on computers located outside your jurisdiction; by providing
            information, you consent to that transfer.
          </p>

          <h2>Disclosure of Data</h2>
          <p>
            We may disclose your data in connection with business transactions,
            to comply with legal obligations, or to protect our rights, users,
            or the public.
          </p>

          <h2>Security of Your Data</h2>
          <p>
            We employ commercially reasonable measures to protect Personal Data,
            but no method of transmission over the Internet or electronic
            storage is 100% secure.
          </p>

          <h2>Children’s Privacy</h2>
          <p>
            Our Service does not address anyone under the age of 13. If you
            believe your child has provided us personal information, please
            contact us so we can remove it.
          </p>

          <h2>Links to Other Websites</h2>
          <p>
            Our Service may contain links to third-party websites. We are not
            responsible for their content or privacy practices; please review
            each site’s Privacy Policy.
          </p>

          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Updates will appear
            on this page with a new “Last updated” date. Please review it
            regularly.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have any questions, contact us via our website contact
            page:&nbsp;
            <a
              href="https://www.maduramercerisers.com/ContactUs"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              www.maduramercerisers.com/ContactUs
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
